import { Theme } from "@mui/material"
import { CustomExternalCatalogWidgetIconTheme } from "core/themes/src/definitions/components.types"

export const createCustomExternalCatalogWidgetIconTheme = (theme: Theme): CustomExternalCatalogWidgetIconTheme => {
    return {
        styleOverrides: {
            root: {
                flex: 1,
                "align-self": "flex-start",
                top: "1em",
                fill: theme.palette.primary.main,
                opacity: 1,
            },
        },
    }
}
